import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled from 'styled-components';
import { th } from '@yoweb/ui/styles/utils/theme';
import { Text, Title } from '@yoweb/ui/components/typography';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { Flex } from '@yoweb/ui/components/Flex';
import { Grid } from '@yoweb/ui/components/Grid';
import { Box } from '@yoweb/ui/components/Box';
import { Divider } from '@yoweb/ui/components/Divider';
import { formatDate } from '@yoweb/utils/date';
import { useTranslation } from '@yoweb/next-i18next';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { RecurringBanner } from './RecurringBanner';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TextualStepLayout = function TextualStepLayout(_ref) {
  var bannerImage = _ref.bannerImage,
      title = _ref.title,
      description = _ref.description,
      taskFeedback = _ref.taskFeedback,
      onClose = _ref.onClose,
      dataTestId = _ref['data-testid'];

  var _useExternalConfig = useExternalConfig(),
      enableRecuringTodos = _useExternalConfig.globalFeatures.enableRecuringTodos;

  var showRecurringBanner = enableRecuringTodos && (taskFeedback === null || taskFeedback === void 0 ? void 0 : taskFeedback.taskIsRepeatable) && !(taskFeedback !== null && taskFeedback !== void 0 && taskFeedback.taskIsRepeating);
  return /*#__PURE__*/_jsx(TextualStepLayoutContent, {
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsxs(AutoRowGrid, {
      justifyItems: "center",
      children: [bannerImage, /*#__PURE__*/_jsx(Box, {
        mt: "normal4",
        children: /*#__PURE__*/_jsx(Title, {
          size: "sm",
          as: "h3",
          children: title
        })
      }), /*#__PURE__*/_jsx(FlyoutTextContainer, {
        children: /*#__PURE__*/_jsx(Text, {
          size: "md",
          textAlign: "center",
          children: description
        })
      }), taskFeedback && showRecurringBanner && /*#__PURE__*/_jsx(RecurringBanner, {
        taskFeedback: taskFeedback,
        onClose: onClose
      })]
    })
  });
};
export var StepGrid = styled(Grid).withConfig({
  componentId: "sc-1vyo9z-0"
})(["&&{width:100%;gap:", ";}"], th.getSpace('normal3'));
var AutoRowGrid = styled(StepGrid).withConfig({
  componentId: "sc-1vyo9z-1"
})(["&&{grid-auto-rows:min-content;align-content:center;gap:", ";}"], th.getSpace('normal1'));
export var FlyoutContentContainer = function FlyoutContentContainer(props) {
  return /*#__PURE__*/_jsx(Box, _objectSpread({
    display: "flex",
    flexDirection: "column",
    rowGap: "normal1"
  }, props));
};
export var FlyoutContent = styled(Flex).withConfig({
  componentId: "sc-1vyo9z-2"
})(["&&{flex:1 1 0%;padding:", " ", " ", ";position:relative;align-items:flex-start;", "}"], th.getSpace('normal2'), th.getSpace('normal2'), th.getSpace('normal2'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      padding: 0 ", " ", ";\n    "])), th.getSpace('normal4'), th.getSpace('normal2')));
var TextualStepLayoutContent = styled(FlyoutContent).withConfig({
  componentId: "sc-1vyo9z-3"
})(["&&{min-height:", ";align-items:center;}"], pxToRem(485));
export var FlyoutTextContainer = styled.div.withConfig({
  componentId: "sc-1vyo9z-4"
})(["text-align:left;", ""], media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    max-width: 80%;\n  "]))));
export var StepHeader = function StepHeader(_ref2) {
  var taskFeedback = _ref2.taskFeedback;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var _useIntlMeta = useIntlMeta(),
      locale = _useIntlMeta.locale,
      timeZone = _useIntlMeta.timeZone;

  var updatedDate = taskFeedback.updated ? formatDate(new Date(taskFeedback.updated), {
    preset: 'shortMonthAndDay',
    locale: locale,
    timeZone: timeZone
  }) : '';
  return /*#__PURE__*/_jsxs(StepHeaderGrid, {
    gap: "small3",
    children: [/*#__PURE__*/_jsx(Flex, {
      gap: "normal2",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(Text, {
        $textTransform: "uppercase",
        weight: "bold",
        size: "sm",
        "data-testid": "completed-todo-date",
        children: t('complete-date', {
          date: updatedDate
        })
      })
    }), /*#__PURE__*/_jsx(Text, {
      style: {
        marginBottom: pxToRem(26)
      },
      children: taskFeedback.name
    }), /*#__PURE__*/_jsx(Divider, {
      variant: "tertiary"
    })]
  });
};
var StepHeaderGrid = styled(Grid).withConfig({
  componentId: "sc-1vyo9z-5"
})(["&&{min-height:", ";}"], pxToRem(72));